import { useEffect, useContext } from "react"
import { ThemeContext } from ".."

import BtnKeyboard from "./images/dialpad.svg?url"
import BtnMute from "./images/muted.svg?url"
import BtnPause from "./images/paused.svg?url"
import IconPhoneGreen from "./images/softphone_phone_green.svg?url"
import IconPhoneRed from "./images/softphone_phone_red.svg?url"
import IconHangup from "./images/hangup.svg?url"

import style from "./style.css?inline"

export { style }
export const images = { BtnKeyboard, BtnMute, BtnPause, IconPhoneGreen, IconPhoneRed, IconHangup }

const Theme = () => {
    const { setImages, addStyle } = useContext(ThemeContext)
    useEffect(() => {
        addStyle("default", style)
        setImages(images)
    }, [])
    return <></>
}

export default Theme
